<template>
    <div class="table-responsive-sm">
        <table class="table table-borderless table-hover">
            <tbody>
                <tr
                    v-for="(record, index) in records"
                    class="table-row"
                    :key="record.id || index"
                >
                    <td
                        class="text-start align-middle text-truncate text-column"
                    >
                        <span class="d-flex align-items-center gap-2">
                            <UserAvatar
                                :user="record"
                                class="avatar-style"
                                size="1.75rem"
                            />
                            <span>
                                {{ record?.name }} {{ record?.isExited ? '(Exited)' : '' }}
                            </span>
                        </span>
                    </td>
                    <td class="text-end align-middle">
                        <div class="d-flex gap-2 w-100 justify-content-end">
                            <button
                                v-if="record?.hash"
                                class="icon-btn icon-btn-primary"
                                @click="$emit('view', record)"
                            >
                                <i class="fi fi-eye"></i>
                            </button>
                            <button
                                class="icon-btn icon-btn-light"
                                @click="$emit('message', record)"
                                v-if="this.$userStore.user.id != record.id && record?.id"
                            >
                                <i class="fi fi-chat"></i>
                            </button>
                            <button
                                class="icon-btn icon-btn-white"
                                @click="openModal(record)"
                                :disabled="record?.isExited"
                            >
                                <i class="fi fi-x"></i>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr
                    v-if="isAppSupport"
                    class="table-row app-support-row"
                    key="appSupport"
                >
                    <td
                        class="text-start align-middle text-truncate text-column"
                        style="color: var(--neutral-800)"
                    >
                        <span class="d-flex align-items-center gap-2">
                            <UserAvatar
                                avatar-icon="fi-support"
                                class="avatar-style"
                                size="1.75rem"
                            />
                            <span>Support Team</span>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <ConfirmModal
        :visible="isModalVisible"
        :title="deleteProps.title"
        :confirm-button-text="deleteProps.confirmButtonText"
        @close="closeModal"
        @confirm="deleteRecord"
    >
        {{ deleteProps.description }}
    </ConfirmModal>
</template>

<script>
import ConfirmModal from '@/components/ConfirmModal.vue';
import UserAvatar from '@/components/UserAvatar.vue';

export default {
    name: 'ActionList',
    components: {
        ConfirmModal,
        UserAvatar,
    },
    props: {
        records: {
            type: Array,
            required: true,
        },
        labelKey: {
            type: String,
            required: true,
        },
        isAppSupport: {
            type: Boolean,
            default: false,
        },
        // buttonConditions: {
        //     view: (user) => user.id == this.$userStore.user.id,
        //     message: (user) => user.id == this.$userStore.user.id,
        //     delete: (user) => user.id == this.$userStore.user.id,
        // },
        buttonConditions: {
            type: Object,
            required: false,
            default: () => ({
                view: true,
            }),
        },
    },
    data() {
        return {
            isModalVisible: false,
            currentRecord: null,
        };
    },
    emits: ['edit', 'delete'],
    computed: {
        deleteProps() {
            if (
                this.currentRecord &&
                this.currentRecord.id == this.$userStore.user.id
            ) {
                return {
                    title: 'Leave Thread?',
                    description: 'Are you sure you want to leave this thread?',
                    confirmButtonText: 'Leave Thread',
                };
            }
            return {
                title: 'Remove User?',
                description: 'Are you sure you want to remove this user from this thread?',
                confirmButtonText: 'Remove User',
            };
        },
    },
    methods: {
        openModal(record) {
            this.isModalVisible = true;
            this.currentRecord = record;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        deleteRecord() {
            this.$emit('delete', this.currentRecord);
            // model needs to be closed by the parent component after successful deletion... this.$refs.actionList.closeModal()
        },
    },
};
</script>

<style scoped>
.table-row {
    max-height: 3.1875rem;
    min-height: 3.1875rem;
    height: 3.1875rem;
    line-height: 1.5;
    border: 1px solid var(--neutral-600);
}

.text-column {
    width: 100%;
    max-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--neutral-900);
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}

tr:nth-child(odd) {
    background-color: var(--neutral-400);
}

tr:nth-child(even) {
    background-color: var(--white);
}

.table {
    font-size: 0.875rem;
    width: 100%;
}

.app-support-row {
    pointer-events: none;
    color: var(--neutral-800);
}
</style>
